import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBrandingConfig } from 'helpers/fakebackend_helper';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('branding_configuration_messages');

// Fetch branding configuration (public endpoint, no auth required)
export const fetchBrandingConfig = createAsyncThunk(
  'BrandingConfiguration/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBrandingConfig();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || st('khong_the_tai_thong_tin_thuong_message')
      );
    }
  }
);